import { render, staticRenderFns } from "./Tech.vue?vue&type=template&id=41557cce&scoped=true"
import script from "./Tech.vue?vue&type=script&lang=js"
export * from "./Tech.vue?vue&type=script&lang=js"
import style0 from "./Tech.vue?vue&type=style&index=0&id=41557cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41557cce",
  null
  
)

export default component.exports